var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getRequest, postRequest } from "./api";
import { fromContinueWatchingDTO, fromMoviesDTO } from "./DTOs";
export var getMovieBlocks = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "blocks";
                return [4 /*yield*/, getRequest(url, params)];
            case 1:
                data = (_a.sent()).data;
                data.items = data.items.map(function (item) {
                    return __assign(__assign({}, item), { movies: fromMoviesDTO(item.movies) });
                });
                return [2 /*return*/, data];
        }
    });
}); };
export var getContinueWatchingList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "progress/continue_watching";
                return [4 /*yield*/, getRequest(url, {
                        lang: params.lang,
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, fromContinueWatchingDTO(data)];
        }
    });
}); };
export var getMoviesList = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var url, queryParams, types, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "movies/list";
                queryParams = __assign({}, options);
                if (options.imdb && options.imdb.length) {
                    queryParams.imdb = options.imdb.toString();
                }
                if (options.rating && options.rating.length) {
                    queryParams.rating = options.rating.toString();
                }
                if (options.year && options.year.length) {
                    queryParams.year = options.year.toString();
                }
                types = [];
                if (options.free) {
                    types.push("avod");
                }
                if (options.premium) {
                    types.push("svod");
                }
                if (options.buy) {
                    types.push("est");
                }
                if (types && types.length) {
                    queryParams.types = types.toString();
                }
                if (options.genres && options.genres.length) {
                    queryParams.genre = options.genres;
                }
                if (options.dubs && options.dubs.length) {
                    queryParams.dub = options.dubs;
                }
                if (options.subs && options.subs.length) {
                    queryParams.sub = options.subs;
                }
                if (options.countries && options.countries.length) {
                    queryParams.country = options.countries;
                }
                return [4 /*yield*/, getRequest(url, queryParams)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: fromMoviesDTO(data.items) })];
        }
    });
}); };
export var searchMovies = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "search/movies";
                return [4 /*yield*/, postRequest(url, {
                        q: params.q,
                        lang: params.lang,
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: fromMoviesDTO(data.items) })];
        }
    });
}); };
export var getGenres = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "genres";
                return [4 /*yield*/, getRequest(url, params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
export var getBlockMovies = function (slug, params) { return __awaiter(void 0, void 0, void 0, function () {
    var url, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "blocks/" + slug;
                return [4 /*yield*/, getRequest(url, params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, __assign(__assign({}, data), { items: fromMoviesDTO(data.items) })];
        }
    });
}); };



//////////////////
// WEBPACK FOOTER
// ./src/services/movie.service.ts
// module id = 22
// module chunks = 1